/**
 * 报关贴纸管理- 侵权审核列表
 *
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2021, all rights reserved. Essa.cn
 */
import React, {Fragment} from 'react';
import {Tabs, Spin, Popover, Badge} from "antd";
import {Link} from "react-router-dom";
import CommonBreadcrumb from "@components/CommonBreadcrumb";
// import CustomsDeclarationStickerSteps from "../Components/CustomsDeclarationStickerSteps";
import Lang from "@/components/Lang/Lang";
import AutoFetchTable from "@/components/AutoFetchTable/AutoFetchTable";
import IconFont from "@components/IconFont/index";
import IconDirectPo from "@components/Icon/IconDirectPo/IconDirectPo";//直达商品图标

import "../CustomsDeclarationStickerList.less";
import dayjs from "dayjs";
class List extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            searchFormOptions:[
                {
                    name:'keyword',
                    cnTitle:'客户',
                    cnTitleId:'KeHu',
                    cnPlaceholder:'请输入客户编码或名称',
                    cnPlaceholderId:'QingShuRuCaiGouShangBianMaHuoMingCheng'
                },
                {
                    name:'poCode',
                    cnTitle:'PO单号',
                    cnTitleId:'PODanHao',
                    cnPlaceholder:'请输入PO单号',
                    cnPlaceholderId:'QingShuRuPODanHao'
                }
            ],
            columns:[
                {
                    cnTitle: '客户信息',
                    dataIndex: 'buyerCode',
                    cnTitleId: 'KeHuXinXi',
                    render: (buyerCode, record) => {
                        return(<Fragment>
                            <p className={'span-red'}><Link to={`/customer/detail?id=${record.buyerId}`} target={'_blank'}>{buyerCode}</Link></p>
                            <p className={'blackLink'}><Link to={`/customer/detail?id=${record.buyerId}`} target={'_blank'}>{record.buyerName}</Link></p>
                        </Fragment>)}
                },
                {
                    cnTitle: 'PO单号',
                    dataIndex: 'poCode',
                    cnTitleId: 'PODanHao',
                    render: (poCode, record) => {
                        return(<div className={"flex-item-ver-center"}>
                            {record.isChinaOrder==1?<span className={"mr_4 flex-item-ver-center"}><IconDirectPo size={24} /></span>:null}{poCode}
                        </div>)}
                },
                {
                    cnTitle: '下单时间',
                    dataIndex: 'poCreateTime',
                    cnTitleId: 'XiaDanShiJian',
                    render: (startTime, record) => startTime?dayjs(startTime).format('YYYY-MM-DD HH:mm'):'-'
                },
                {
                    cnTitle: '侵权商品数',
                    dataIndex: 'poSkuCount',
                    cnTitleId: 'QinQuanShangPinShu',
                },
                {
                    cnTitle: '订单提交时长',
                    dataIndex: 'poCreateTime',
                    cnTitleId: 'DingDanTiJiaoShiZhang',
                    type:'millisecondToTime',
                },
                {
                    cnTitle: '操作',
                    dataIndex: 'CaoZuo',
                    width: 100,
                    cnTitleId: 'CaoZuo',
                    render: (item = {}, record) => (<Popover content={Lang({id: 'QuChuLi',default:'去处理'})}>
                                <Link className="link" to={
                                    {
                                        pathname: '/customsDeclarationSticker/reviewWork', //todo
                                        search: `?${record.id}`,
                                    }
                                }>
                                    <IconFont
                                        type="icon-xiangqing-moren-icon"
                                        className="hover-hide"
                                        style={{ fontSize: "32px" }}
                                    ></IconFont>
                                    <IconFont
                                        type="icon-xiangqing-xuanzhong-icon"
                                        className="hover-show"
                                        style={{ fontSize: "32px" }}
                                    ></IconFont>
                                </Link>
                    </Popover>)},
            ],
            columnsReviewed:[
                {
                    cnTitle: '客户信息',
                    dataIndex: 'buyerCode',
                    cnTitleId: 'KeHuXinXi',
                    render: (buyerCode, record) => {
                        return(<Fragment>
                            <p className={'span-red'}><Link to={`/customer/detail?id=${record.buyerId}`} target={'_blank'}>{buyerCode}</Link></p>
                            <p className={'blackLink'}><Link to={`/customer/detail?id=${record.buyerId}`} target={'_blank'}>{record.buyerName}</Link></p>
                        </Fragment>)}
                },
                {
                    cnTitle: 'PO单号',
                    cnTitleId: 'PODanHao',
                    dataIndex: 'poCode',
                    render: (poCode, record) => {
                        return(<div className={"flex-item-ver-center"}>
                            {record.isChinaOrder==1?<span className={"mr_4 flex-item-ver-center"}><IconDirectPo size={24} /></span>:null}{poCode}
                        </div>)}
                },
                {
                    cnTitle: '下单时间',
                    dataIndex: 'poCreateTime',
                    cnTitleId: 'XiaDanShiJian',
                    render: (startTime, record) => startTime?dayjs(startTime).format('YYYY-MM-DD HH:mm'):'-'
                },
                {
                    cnTitle: '商品款数',
                    dataIndex: 'poSkuCount',
                    cnTitleId: 'ShangPinKuanShu',
                },
                {
                    cnTitle: '处理人',
                    dataIndex: 'handleName',
                    cnTitleId: 'ChuLiRen',
                    render: (handleName, record) => record.handleTime?<Fragment><span>{handleName}</span><span style={{marginLeft:'5px'}}>{dayjs(record.handleTime).format('YYYY-MM-DD HH:mm')}</span></Fragment>:handleName
                },
                {
                    cnTitle: '操作',
                    dataIndex: 'CaoZuo',
                    width: 100,
                    cnTitleId: 'CaoZuo',
                    render: (item = {}, record) => (<Popover content={Lang({id: 'View',default:'查看'})}>
                        <Link className="link" to={
                            {
                                pathname: '/customsDeclarationSticker/reviewDetail', //todo
                                search: `?${record.id}`,
                            }
                        }>
                            <IconFont
                                type="icon-xiangqing-moren-icon"
                                className="hover-hide"
                                style={{ fontSize: "32px" }}
                            ></IconFont>
                            <IconFont
                                type="icon-xiangqing-xuanzhong-icon"
                                className="hover-show"
                                style={{ fontSize: "32px" }}
                            ></IconFont>
                        </Link>
                    </Popover>)
                },
            ],
            auditStatus:'0',//默认审核状态 审核状态
            total: 0,
        }
    }
    /**
     * 改变状态
     **/
    changeTab(activeKey){
        this.setState({
            auditStatus:activeKey
        },()=>{
            switch (activeKey) {
                case '1':
                    if(this.onRefTabChildTwo){
                        this.onRefTabChildTwo.handleFetch()
                    }
                    break
                default:
                    if(this.onRefTabChildOne){
                        this.onRefTabChildOne.handleFetch()
                    }
            }
        })
    }
    fetchCallBack(res){
        const {success,valid,paging} = res;
        if (success && valid) {
            this.setState({
                total:paging&&paging.total?paging.total:0
            })
        }else this.setState({
            total: 0
        })
    }
    onRefTabOne = (ref) =>  this.onRefTabChildOne = ref;
    onRefTabTwo = (ref) =>  this.onRefTabChildTwo = ref;
    render(){
        const { loading,searchFormOptions,columns,auditStatus,columnsReviewed,total } = this.state;

        const currPageName = Lang({id: "QinQuanShenHe",default: "侵权审核"});
        return (<Spin tip='loading' spinning={loading}>
                {/*<CustomsDeclarationStickerSteps current={0} />*/}
                <CommonBreadcrumb list={[{ name:currPageName}]}></CommonBreadcrumb>
                <div className={'customsDeclarationStickerListStyle'}>
                    <Tabs defaultActiveKey={auditStatus} onChange={(activeKey)=>this.changeTab(activeKey)}
                          items={[
                              {
                                  key: '0',
                                  label:(<div>
                                      <span className="mr_4">{ Lang({id: 'DaiShenHe', default: '待审核'})}</span>
                                      <Badge count={total}></Badge>
                                  </div>),
                                  children:(<div className={'content'}>
                                      <AutoFetchTable columns={columns}
                                                      flagShowReset={false}
                                                      rowKey={'id'}
                                                      searchFormOptions={searchFormOptions}
                                                      onRef={this.onRefTabOne}
                                                      fetchCallBack={(res)=>this.fetchCallBack(res)}
                                                      precondition={{
                                                          eventCode: 20,
                                                          auditStatus:Number(auditStatus),
                                                      }}
                                                      fetchApi={'/service/mg/sticker/track/list'} />
                                  </div>)
                              }, {
                                  key: '1',
                                  label: Lang({id: 'YiShenHe', default: '已审核'}),
                                  children:( <div className={'content'}>
                                      <AutoFetchTable columns={columnsReviewed}
                                                      flagShowReset={false}
                                                      searchFormOptions={searchFormOptions}
                                                      onRef={this.onRefTabTwo}
                                                      rowKey={'id'}
                                                      precondition={{
                                                          eventCode: 20,
                                                          auditStatus:Number(auditStatus),
                                                      }}
                                                      fetchApi={'/service/mg/sticker/track/list'} />

                                  </div>)
                              }
                          ]}
                    >
                    </Tabs>
                </div>
            </Spin>

        )
    }
}

export default List;
